import React, { Fragment } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
// import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Hero from './Hero';
// import IconImage from '../images/icon-developer.png';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedin, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';

library.add(faFacebook, faLinkedin, faTwitter, faInstagram);

const styles = theme => ({
    root: {

    },
    container: {
        width: '90%',
        margin: '0 auto',
        padding: '20px 0',
    },
    heroContent: {
        width: '60%',
        margin: '0 auto',
        padding: '20px 0',
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        },
    },
    heroHeader: {
        fontSize: '50px',
        fontWeight: '400',
        color: '#FFFFFF',
        textAlign: 'center',
        margin: '120px 0 20px 0',
        [theme.breakpoints.down('sm')]: {
            fontSize: '30px',
            margin: '60px 0 20px 0',
        },
        '&::after': {
            display: 'block',
            width: '2.5em',
            height: '3px',
            background: '#51e3d4',
            content: '" "',
            margin: '7px auto',
            borderRadius: '2px'
        }
    },
    heroText: {
        fontSize: '20px',
        margin: '20px 0 120px 0',
        color: '#FFFFFF',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '17px',
            margin: '20px 0 60px 0',
        },
    },
    textHeading: {
        margin: '15px 0',
        fontSize: '30px',
        fontWeight: '700',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '22px',
        },
    },
    textDescription: {
        fontSize: '18px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },
    workImage: {
        width: '100%',
        height: 'auto'
    },
    maintenanceDiv: {
        margin: '180px 0',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            margin: '120px 0'
        }
    },
    maintenanceHeader: {
        margin: '10px 0',
        fontSize: '60px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '30px'
        }
    },
    maintenanceText: {
        margin: '10px 0',
        fontSize: '35px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '25px'
        }
    },
    social: {
        textAlign: 'center',
        marginBottom: '30px',
        '& a': {
            marginRight: '15px',
            fontSize: '1.5rem',
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    facebook: {
        color: '#3b5998',
    },
    twitter: {
        color: '#1DA1F2',
    },
    linkedin: {
        color: '#0077B5',
    },
    instagram: {
        color: '#fb3958',
    },
});



const PortfolioContent = (props) => {
    const { classes } = props;
    return (
        <Fragment>
            <Hero image="portfolio.png">
                <div className={classes.heroContent}>
                    <Typography variant="h1" className={classes.heroHeader}>Portfolio</Typography>
                    <Typography variant="body1" className={classes.heroText}>Our endeavor is to provide our clients awesome Software services and solutions to promote growth of their business to the highest level.</Typography>
                </div>
            </Hero>
            <section className={classes.container}>
                <div className={classes.maintenanceDiv}>
                    <Typography variant="h1" className={classes.maintenanceHeader}>This Page is under maintenance</Typography>
                    <Typography variant="h1" className={classes.maintenanceText}>Follow us for updates</Typography>
                    <div className={classes.social}>
                        <a className={classes.facebook} target="_blank" rel="noopener noreferrer" href="http://www.facebook.com"><FontAwesomeIcon icon={faFacebook} /></a>
                        <a className={classes.twitter} target="_blank" rel="noopener noreferrer" href="http://www.twitter.com"><FontAwesomeIcon icon={faTwitter} /></a>
                        <a className={classes.linkedin} target="_blank" rel="noopener noreferrer" href="http://www.linkedin.com"><FontAwesomeIcon icon={faLinkedin} /></a>
                        <a className={classes.instagram} target="_blank" rel="noopener noreferrer" href="http://www.instagram.com"><FontAwesomeIcon icon={faInstagram} /></a>
                    </div>
                </div>
                {/* <Typography variant="h3" className={classes.textHeading}>OUR RECENT WORKS</Typography>
                <Fragment>
                    <Grid container>
                        <Grid container item xs={12} sm={6}>
                            <Grid item xs={12} sm={6}>
                                <img src={IconImage} alt="iconImage" className={classes.workImage} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="inherit">ECommerce<br />Solution</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Fragment> */}
            </section>
        </Fragment>
    );
}

PortfolioContent.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(PortfolioContent);